import { Component, input, Input, output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { M_STORE_BOARD } from '../../../models/M_STORE_BOARD'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'components-notice-detail',
  imports: [CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './notice-detail.component.html',
  styleUrl: './notice-detail.component.css',
})
export class NoticeDetail {
  @Input() safeContentMap = new Map<number, SafeHtml>()
  @Input() notice = new M_STORE_BOARD()
  open = input(false);
  close = output<void>();

  cleanName(name: string) {
    return name.replace(/_\d{14}(?=\.)/, '');
  }

  onClose() {
    this.close.emit();
  }

  review(item: any) {
    switch (item.kind) {
      case 'image':
      case 'video':
        window.open(item.previewUrl, '_blank');
        break;

      case 'pdf':
        window.open(item.previewUrl, '_blank');
        break;

      case 'docx':
      case 'excel':
      case 'txt':
        this.downloadFile(item);
        break;

      default:
        this.downloadFile(item);
        break;
    }
  }

  async downloadFile(item: any) {
    const response = await fetch(item.previewUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = item.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  }

}
